var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 64 64"}},[_c('title',[_vm._t("default",function(){return [_vm._v("Menu")]})],2),_c('rect',{attrs:{"x":"12","y":"14","width":"40","height":"2","rx":"1"}}),_c('rect',{attrs:{"x":"12","y":"31","width":"40","height":"2","rx":"1"}}),_c('rect',{attrs:{"x":"12","y":"48","width":"40","height":"2","rx":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }